import { faArrowRight, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormHelperText, FormLabel, Input } from "@mui/joy";
import { Switch } from "@mui/material"; // Importing Switch from MUI
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";

import {
  checkEmail,
  checkUsername,
  initiateQR,
  sendOtp,
  verifyCode,
  signup,
  verifyOtp ,
} from "../services/user-service";
import { Emailtemplate, EmailTemplatePostfix } from "./Emailtemplate";
 import "./SignupPage.css";
 import TermsAndConditionsModal from "./TermsAndConditionsModal";
import { useNavigate } from "react-router-dom";
import { changeUsFormatNumber } from "../components/Common";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { subYears, format } from 'date-fns';
import axios from "axios";
import { QRCodeSVG } from "qrcode.react";
const steps = [
  {
    label: "Personal Information",
    description: "Add your personal information",
  },
  {
    label: "Address Information",
    description: "Add your address information",
  },
  {
    label: "Account Information",
    description: "Add your account information",
  },
  {
    label: "Security",
    description: "Google Authenticator",
  },
  
];


const Signup = ({ onBack }) => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(0);
  const [formValues, setFormValues] = React.useState({
    personalInformation: {
      firstName: "",
      lastName: "",
      email: "",
      dob: "",
      gender: "",
      phoneNo: "",
    },
    addressInformation: {
      street: "",
      apartment: "",
      city: "",
      zip: "",
      country: "",
      state: "",
    },
    accountInformation: {
      username: "",
      password: "",
      confirmPassword: "",
      role: "USER",
      jointAccount: false,
      accountType: "normal",
      secretKey: ""
    },
  });
  const [errors, setErrors] = React.useState({
    personalInformation: {
      firstName: false,
      email: false,
      emailValid: true,
      firstNameValidate: true,
      lastNameValidate: true,
      dob: false,
      gender: false,
      phoneNo: false,
      phoneNumberValid: true,
    },
    addressInformation: {
      street: false,
      zip: false,
      zipValidate: true,
      validZip: true,
    },
    accountInformation: {
      username: false,
      password: false,
      confirmPassword: false,
      passwordMatch: true,
      passwordValid: true,
      usernameValid: true,
    },
    });
  const [showPassword, setShowPassword] = React.useState(false);
  const [showTermCondtitions, setShowTermCondtitions] = React.useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
const [otpLoading, setOtpLoading] = useState(false);
const [termsModalOpen, setTermsModalOpen] = React.useState(false);
const [hasAcceptedTerms, setHasAcceptedTerms] = React.useState(false);

  const validateAlphanumeric = (value) => {
    return !/^\d+$/.test(value);
  };
  
  const validateStreet = (street) => {
    return /^[A-Za-z0-9\s]+$/.test(street); // Alphanumeric with spaces allowed
  };
  
  const validateApartment = (apartment) => {
    return /^[A-Za-z0-9\s]+$/.test(apartment); // Alphanumeric with spaces allowed
  };
  
  const validateZipCode = (zipCode) => {
    return /^\d{5}$/.test(zipCode);
  };

const validateEmail = (email) => {
  const re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  return re.test(email);
};
  const validatePhoneNumber = (phoneNo) => {
    const re = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;
    return re.test(phoneNo);
  };

  const validatePassword = (password) => {
    const re = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_-])[A-Za-z\d@$!%*?&_-]{10,}$/;
    return re.test(password);
  };

const validateUsername = (username) => {
  const isEmail = /\S+@\S+\.\S+/.test(username);
  const validPattern = /^[a-z][a-z0-9_]*$/;
  return !isEmail && validPattern.test(username);
};

  const checkEmailExists = (email) => {
    return new Promise((resolve, reject) => {
      if (email !== "" && validateEmail(email)) {
        checkEmail(email)
          .then((res) => {
            if (res === true) {
              resolve(res); 
            } else {
              resolve(res);  
            }
          })
          .catch((err) => {
            toast.error("Error");
            reject(err);  
          });
      } else {
        resolve(false);  
      }
    });
  };

  const checkUsernameExists = (username) => {
    return new Promise((resolve, reject) => {
      if (username !== "") {
        checkUsername(username)
          .then((res) => {
            if (res === true) {
              resolve(res);  
            } else {
              resolve(res);  
            }
          })
          .catch((err) => {
            toast.error("Error");
            reject(err);  
          });
      } else {
        resolve(false);  
      }
    });
  };
  
  const [validateExistsEmail, setValidateExistsEmail] = useState(false);
  const [validateExistsUsername, setValidateExistsUsername] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [emailOtpSent, setEmailOtpSent] = useState(false);

  const [generateQR, setGenerateQR] = useState(false);
  const [qr, setQr] = useState(null);  
  const [otp, setOtp] = useState("");  
  const [secret, setSecret] = useState("");  
  const [otpVerified, setOtpVerified] = useState(false);
const getQR = () => {
  const username = usernameRef.current || formValues.accountInformation.username;
  const payload = { username };

  console.log("Generating QR for:", username);

  initiateQR(payload)
    .then((res) => {
      setQr(res);
      extractSecret(res);
    })
    .catch(() => {
      toast.error("Error fetching QR Code");
    });
};

   const extractSecret = (qrString) => {
    const urlParams = new URLSearchParams(qrString.split("?")[1]);  
    const extractedSecret = urlParams.get("secret");  

    setFormValues((prevValues) => ({
      ...prevValues,
      accountInformation: {
        ...prevValues.accountInformation,
        secretKey: extractedSecret,  
      },
    }));

   };

  const [otpMessage, setOtpMessage] = useState("");
  const [otpSuccess, setOtpSuccess] = useState(false);
   const verifyCodeValue = () => {
   
  const username = formValues.accountInformation.username.toLowerCase();
    if (otp.length !== 6) {
    toast.error("OTP must be exactly 6 digits.");
    return;
  }  
  const payload = {
      username: formValues.accountInformation.username,
      otp: otp,
    };

     const userInformation = updateCombinedInformation(formValues);

    verifyCode(payload)
      .then((res) => {
        if (res) {
          toast.success("OTP verified successfully! 🎉");
           setOtpVerified(true);
           } else {
          toast.error("Invalid OTP. Please try again. ❌");
          setOtp("");
        }
      })
      .catch((err) => {
        toast.error("Verification failed. Please try again later.");
        setOtp(""); 
      });
  };
const isAtLeast18YearsOld = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();

  const ageDiff = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  if (ageDiff > 18) return true;
  if (ageDiff === 18) {
    if (monthDiff > 0) return true;
    if (monthDiff === 0 && dayDiff >= 0) return true;
  }

  return false;
};

  const handleNext = async () => {
    if (activeStep === 0) {
      const { firstName, lastName, email, dob, gender, phoneNo } =
        formValues.personalInformation;
      const emailValid = validateEmail(email);
      const phoneNumberValid = validatePhoneNumber(phoneNo);
      const firstNameValidate = validateAlphanumeric(firstName);
      const is18OrOlder = isAtLeast18YearsOld(dob);

      const lastNameValidate =
        lastName === "" ? true : validateAlphanumeric(lastName);

      try {
        const isEmailExist = await checkEmailExists(email);
        if (isEmailExist) {
          setValidateExistsEmail(isEmailExist);
          return;
        }
      } catch (err) {
        toast.error("Error");
      }

      setErrors({
        personalInformation: {
          firstName: !firstName,
          email: !email,
          emailValid,
          firstNameValidate,
          lastNameValidate,
          dob: !dob|| !is18OrOlder,
          gender: !gender,
          phoneNo: !phoneNo,
          phoneNumberValid,
        },
        addressInformation: errors.addressInformation,
        accountInformation: errors.accountInformation,
     });
      if (!firstName) {
        toast.error("First name is required.");
        return;
      }
      if (!email) {
        toast.error("Email is required.");
        return;
      }
      if (!emailValid) {
        toast.error("Please enter a valid email address.");
        return;
      }
      if (!firstNameValidate) {
        toast.error("First name must be alphanumeric.");
        return;
      }
      if (!lastNameValidate) {
        toast.error("Last name must be alphanumeric.");
        return;
      }
      if (!dob) {
        toast.error("Date of Birth is required.");
        return;
      }
      if (!is18OrOlder) {
        toast.error("User must be at least 18 years old.");
        return;
      }
      if (!gender) {
        toast.error("Gender is required.");
        return;
      }
      if (!phoneNo) {
        toast.error("Phone number is required.");
        return;
      }
      if (!phoneNumberValid) {
        toast.error("Invalid phone number format.");
        return;
      }
    }

    if (activeStep === 1) {
      const { street, city, zip, country, state } =
        formValues.addressInformation;

     const zipValidate = validateZipCode(zip);
      const streetValidate = validateStreet(street);
      const validZip = errors.addressInformation.validZip;
      setErrors({
        personalInformation: errors.personalInformation,
        accountInformation: errors.accountInformation,
        addressInformation: {
          street: !street,
          streetValidate,  
          zip: !zip,
          zipValidate,
          validZip,
        },
       });
        if (
        !street ||
        !state ||
        !zip ||
        !zipValidate ||
        !validZip
          ) {
        return;
      }
    }

    if (activeStep === 2) {
      const { username, password, confirmPassword, isGoogleAuthEnabled  } =
        formValues.accountInformation;
      const passwordMatch = password === confirmPassword;
      const passwordValid = validatePassword(password);
      const usernameValid = validateUsername(username);
        if (!hasAcceptedTerms) {
    toast.error("Please accept the Terms and Conditions.");
    return;
  }
      try {
        const isUsernameExist = await checkUsernameExists(username);
        if (isUsernameExist) {
          setValidateExistsUsername(isUsernameExist);
          return;
        } else {
          if (generateQR === false) {
            setGenerateQR(true);
          }
        }
      } catch (err) {
        toast.error("Error");
      }

      setErrors({
        personalInformation: errors.personalInformation,
        accountInformation: {
          username: !username,
          password: !password,
          confirmPassword: !confirmPassword,
          passwordMatch: passwordMatch,
          passwordValid: passwordValid,
          usernameValid: usernameValid,
        },
        addressInformation: errors.addressInformation,
      });

      if (
        !username ||
        !password ||
        !confirmPassword ||
        !passwordMatch ||
        !passwordValid ||
        !usernameValid
      ) {
        return;
      }
       
    }

    if (activeStep === 3) {
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleEmailChange = async (e) => {
  const email = e.target.value;
  setFormValues((prev) => ({
    ...prev,
    personalInformation: {
      ...prev.personalInformation,
      email,
    },
  }));

  const emailValid = validateEmail(email);

  if (emailValid) {
    try {
      const exists = await checkEmailExists(email);
      setValidateExistsEmail(exists);
    } catch (err) {
      toast.error("Error checking email.");
    }
  } else {
    setValidateExistsEmail(false); 
  }

  setErrors((prev) => ({
    ...prev,
    personalInformation: {
      ...prev.personalInformation,
      email: !email,
      emailValid,
    },
  }));
};

useEffect(() => {
  if (activeStep === 3 && !emailOtpSent) {
      setOtpLoading(true);
      sendOtp({
      to: formValues.personalInformation.email,
      subject: "Login OTP",
      message: Emailtemplate,
      postfixMessage: EmailTemplatePostfix,
    })
      .then(() => {
        toast.success("OTP sent to your email.");
        setEmailOtpSent(true);
      })
      .catch(() => {
        toast.error("Failed to send OTP");
      })     
       .finally(() => {
        setOtpLoading(false);
      });
  }
}, [activeStep, emailOtpSent, formValues.personalInformation.email]);
const handleEmailOtpVerify = (e) => {
  e.preventDefault();

  if (emailOtp.length !== 6) {
    toast.error("Please enter a valid 6-digit OTP");
    return;
  }

  verifyOtp({ usermail: formValues.personalInformation.email, otp: emailOtp })
    .then((res) => {
      if (res === true) {
        setIsEmailVerified(true);
        toast.success("Email verified successfully!");
      } else {
        toast.error("Invalid OTP. Please try again.");
        setEmailOtp("");
      }
    })
    .catch(() => {
      toast.error("OTP verification failed");
      setEmailOtp("");
    });
};

  useEffect(() => {
    if (generateQR === true) {
      getQR();
    }
  }, [generateQR]);

  const updateCombinedInformation = (formValues) => ({
    ...formValues.personalInformation,
    ...formValues.addressInformation,
    ...formValues.accountInformation,
  });

   const [userAllInformation, setUserAllInformation] = useState({});

  const handleRegister = async (userInformation) => {
    try {
      const resp = await signup(userInformation);  

      toast.success("User registered successfully 🎉");
  
       window.location.href="/";
     } catch (error) {
      toast.error("Registration failed");
      const errorMessage = error.response?.data?.message || "Registration failed. Please try again.";
      toast.error(errorMessage);
    }
  };
  
  const handleResendOtp = () => {
  setOtpLoading(true);
  sendOtp({
    to: formValues.personalInformation.email,
    subject: "Login OTP",
    message: Emailtemplate,
    postfixMessage: EmailTemplatePostfix,
  })
    .then(() => {
      toast.success("OTP resent successfully.");
      setEmailOtp(""); // reset the input
    })
    .catch(() => {
      toast.error("Failed to resend OTP");
    })
    .finally(() => {
      setOtpLoading(false);
    });
};

   const handleSubmit = async (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    const userInformation = updateCombinedInformation(formValues);
    setUserAllInformation(userInformation);
    if (
      validateUsername(userInformation.username) &&
      errors.accountInformation.usernameValid &&
      errors.accountInformation.passwordMatch
    ) {
       const payload = {
        username: userInformation.username,
        otp: otp,
      };
  
      try {
        const res = await verifyCode(payload);
        if (res) {
          toast.success("OTP verified successfully! 🎉");
          await handleRegister(userInformation);
        } else {
          toast.error("Invalid OTP. Please try again. ❌");
          setOtp("");
        }
      } catch (err) {
        toast.error("Verification failed. Please try again later.");
        setOtp("");
      }
    } else {
      toast.error("Please complete all required fields and verify OTP.");
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setValidateExistsEmail(false);
    setValidateExistsUsername(false);
  };

  const handleReset = () => {
    setActiveStep(0);
    setFormValues({
      personalInformation: {
        firstName: "",
        lastName: "",
        email: "",
        dob: "",
        gender: "",
        phoneNo: "",
      },
      addressInformation: {
        street: "",
        city: "",
        zip: "",
        country: "",
        state: "",
      },
      accountInformation: { username: "", password: "", confirmPassword: "" },
     });
    setErrors({
      personalInformation: {
        firstName: false,
        email: false,
        emailValid: true,
        firstNameValidate: true,
        lastNameValidate: true,
        dob: false,
        gender: false,
        phoneNo: false,
        phoneNumberValid: true,
      },
      addressInformation: {
        street: false,
        city: false,
        zip: false,
        country: false,
        state: false,
      },
      accountInformation: {
        username: false,
        password: false,
        confirmPassword: false,
        passwordMatch: true,
        passwordValid: true,
        usernameValid: true,
        
      },
   });
  };

const getMax18YearsOldDate = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 18);
  return today.toISOString().split("T")[0]; 
};
const usernameRef = useRef("");

const maxDOB = getMax18YearsOldDate();
  const handleInputChange = (e, section, field) => {
    let  value = e.target.value;

  
    if (field === "phoneNo") {
      const formattedValue = changeUsFormatNumber(value);

      setFormValues({
        ...formValues,
        [section]: {
          ...formValues[section],
          [field]: formattedValue,
        },
      });
    } else if (field === "zip") {
      if (/^\d{0,5}$/.test(value)) {
         setFormValues({
          ...formValues,
          [section]: {
            ...formValues[section],
            ["zip"]: value,
          },
        });
      }
    } else if (field === "dob") {
      if (value > maxDOB) {
        toast.error("You must be at least 18 years old to register.", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return;
      } else {
        setFormValues({
          ...formValues,
          [section]: {
            ...formValues[section],
            dob: value,
          },
        });
      }
    }

    else {
      setFormValues({
        ...formValues,
        [section]: {
          ...formValues[section],
          [field]: value,
        },
      });
    }

    if (errors[section]) {
      setErrors({
        ...errors,
        [section]: {
          ...errors[section],
          [field]: !value,
          ...(field === "email" && { emailValid: validateEmail(value.toLowerCase()) }),
          ...(field === "firstName" && {
            firstNameValidate: validateAlphanumeric(value),
          }),
          ...(field === "lastName" && {
            lastNameValidate: value === "" ? true : validateAlphanumeric(value),
          }),
          ...(field === "phoneNo" && {
            phoneNumberValid: validatePhoneNumber(changeUsFormatNumber(value)),
          }),
          ...(section === "addressInformation" && {

            ...(field === "zip" && {
              zipValidate: validateZipCode(value.slice(0, 5)),
            }),
          }),
          ...(section === "accountInformation" &&
            field === "confirmPassword" && {
              passwordMatch: value === formValues.accountInformation.password,
            }),
          ...(section === "accountInformation" &&
            field === "password" && {
              passwordMatch:
                value === formValues.accountInformation.confirmPassword,
              passwordValid: validatePassword(value),
            }),
          ...(section === "accountInformation" &&
            field === "username" && {
              usernameValid: validateUsername(value.toLowerCase()),
              ...(usernameRef.current = value.toLowerCase()),
            }),
        },
      });
    }
  };

  useEffect(() => {
    const fetchDataFromAPI = () => {
      if (formValues.addressInformation.zip.length === 5) {
        const apiUrl = `https://api.zippopotam.us/us/${formValues.addressInformation.zip}`;
        axios
          .get(apiUrl)
          .then((res) => {
            if (res.data && res.data.places && res.data.places.length > 0) {
              const place = res.data.places[0];
              const city = place["place name"];
              const state = place["state abbreviation"];
              const country = res.data["country abbreviation"];

              setFormValues((prevState) => ({
                ...prevState,
                addressInformation: {
                  ...prevState.addressInformation,
                  city: city,
                  state: state,
                  country: country,
                },
              }));
              setErrors((prevState) => ({
                ...prevState,
                addressInformation: {
                  ...prevState.addressInformation,
                  validZip: true,
                },
              }));
            }
          })
          .catch((error) => {
            setErrors((prevState) => ({
              ...prevState,
              addressInformation: {
                ...prevState.addressInformation,
                validZip: false,
              },
            }));
          });
      } else {
        setFormValues((prevState) => ({
          ...prevState,
          addressInformation: {
            ...prevState.addressInformation,
            city: "",
            state: "",
            country: "",
          },
        }));
      }
    };

    fetchDataFromAPI();
  }, [formValues.addressInformation.zip]);

  const handleSelectChange = (e, section, field) => {
    const value = e.target.value;

    
  };

  const handleCheckboxChange = (fieldName) => (event) => {
    if (fieldName === "showPassword") {
      setShowPassword(event.target.checked);
    }
    if (fieldName === "termConditions") {
      setShowTermCondtitions(event.target.checked);
    }
  };

  

  let signIn = "register";
  

  return (
    <>
      
        <div className="login-popup page">
          <div className="signup">
            <Card className="signup_card">
              <div className="signup_heading">
                <p>Create Your Account</p>
                <div className="signup_cancel_icon">
                  <FontAwesomeIcon
                    className="cancel_icon"
                    icon={faTimes}
                    onClick={onBack}
                  />
                </div>
              </div>
              <div className="signup_form_card_main">
                <Stepper
                  activeStep={activeStep}
                  orientation=""
                  className="banrakas"
                >
                  {steps.map((step, index) => (
                    <Step key={step.label}>
                      <StepLabel>{step.label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
                <Box className="stepper_form" sx={{ width: "100%" }}>
                  <form onSubmit={handleSubmit} className="signup_submit_form">
                    <div className="signup_submit_form_design">
                      {activeStep === 0 && (
                        <>
                          <div>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                errors.personalInformation.firstName
                              )}
                            >
                              <FormLabel required>First Name</FormLabel>
                              <Input
                                className="input_mui_joy"
                                placeholder="Enter First Name"
                                required
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    "personalInformation",
                                    "firstName"
                                  )
                                }
                                value={formValues.personalInformation.firstName}
                              />
                              {(errors.personalInformation.firstName ||
                                !errors.personalInformation
                                  .firstNameValidate) && (
                                <FormHelperText error>
                                  <Typography variant="caption" color="error">
                                    {errors.personalInformation.firstName
                                      ? "First Name is required"
                                      : !errors.personalInformation.firstName
                                      ? "Enter valid first name"
                                      : ""}
                                  </Typography>
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>

                          <div>
                            <FormLabel>Last Name</FormLabel>
                            <Input
                              className="input_mui_joy"
                              placeholder="Enter Last Name"
                              value={formValues.personalInformation.lastName}
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  "personalInformation",
                                  "lastName"
                                )
                              }
                            />
                            {!errors.personalInformation.lastNameValidate && (
                              <FormHelperText error>
                                <Typography variant="caption" color="error">
                                  Enter valid last name
                                </Typography>
                              </FormHelperText>
                            )}
                          </div>

                          <div>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                errors.personalInformation.email ||
                                !errors.personalInformation.emailValid
                              )}
                            >
                              <FormLabel>Email*</FormLabel>
                              <Input
                                className="input_mui_joy"
                                required
                                placeholder="Enter Email"
                                value={formValues.personalInformation.email}
                                onChange={(e) =>{
                                  const newEmail = e.target.value;
                                  handleInputChange(e, "personalInformation", "email")
                                  setValidateExistsEmail(false);
                                }}
                                onBlur={(e) => {
                                  const lowerEmail = e.target.value.toLowerCase();
                                  setFormValues((prev) => ({
                                    ...prev,
                                    personalInformation: {
                                      ...prev.personalInformation,
                                      email: lowerEmail,
                                    },
                                  }));
                                }}
                              />
                              {(errors.personalInformation.email ||
                                !errors.personalInformation.emailValid ||
                                validateExistsEmail) && (
                                <FormHelperText>
                                  <Typography variant="caption" color="error">
                                    {errors.personalInformation.email
                                      ? "Email is required"
                                      : !errors.personalInformation.emailValid
                                      ? "Enter a valid email"
                                      : validateExistsEmail
                                      ? "Email already exist"
                                      : ""}
                                  </Typography>
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                          <div>
                            <FormControl
                              fullWidth
                              error={Boolean(errors.personalInformation.dob)}
                            >
                              <FormLabel shrink>Date of Birth*</FormLabel>
                              <Input
                                type="date"
                                required
                                value={formValues.personalInformation.dob}
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    "personalInformation",
                                    "dob"
                                  )
                                }
                                slotProps={{
                                  input: {
                                    max: maxDOB,
                                  },
                                }}
                              />
                              {errors.personalInformation.dob && (
                                <FormHelperText error>
                                  <Typography variant="caption" color="error">
                                    Date of Birth is required
                                  </Typography>
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                          <div>
                            <FormControl
                              fullWidth
                              error={Boolean(errors.personalInformation.gender)}
                            >
                              <FormLabel>Gender*</FormLabel>
                              <Select
                                value={formValues.personalInformation.gender}
                                required
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    "personalInformation",
                                    "gender"
                                  )
                                }
                                displayEmpty
                                sx={{ height: "40px" }}
                              >
                                <MenuItem value="" disabled>
                                  Select Your Gender
                                </MenuItem>
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>
                                <MenuItem value="Other">Other</MenuItem>
                              </Select>
                              {errors.personalInformation.gender && (
                                <FormHelperText>
                                  <Typography variant="caption" color="error">
                                    Gender is required
                                  </Typography>
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                          <div>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                errors.personalInformation.phoneNo ||
                                  !errors.personalInformation.phoneNumberValid
                              )}
                            >
                              <FormLabel>Phone Number*</FormLabel>
                              <Input
                                className="input_mui_joy"
                                required
                                placeholder="Enter Phone Number"
                                value={formValues.personalInformation.phoneNo}
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    "personalInformation",
                                    "phoneNo"
                                  )
                                }
                              />
                              {(errors.personalInformation.phoneNo ||
                                !errors.personalInformation
                                  .phoneNumberValid) && (
                                <FormHelperText>
                                  <Typography variant="caption" color="error">
                                    {errors.personalInformation.phoneNo
                                      ? "Phone Number is required"
                                      : !errors.personalInformation
                                          .phoneNumberValid
                                      ? "Enter a valid phone number"
                                      : ""}
                                  </Typography>
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                        </>
                      )}
                      {activeStep === 1 && (
                        <>
                         <div>
                          <FormLabel required>Street</FormLabel>
                          <Input
                            className="input_mui_joy"
                            placeholder="Enter Street"
                            value={formValues.addressInformation.street}
                            onChange={(e) =>
                              handleInputChange(e, "addressInformation", "street")
                            }
                          />
                          {errors.addressInformation.street && (
                            <FormHelperText error>
                              <Typography variant="caption" color="error">
                                Street is required
                              </Typography>
                            </FormHelperText>
                          )}
                        </div>


                          <div>
                            <FormLabel>Apartment</FormLabel>
                            <Input
                              className="input_mui_joy"
                              placeholder="Enter Apartment"
                              value={formValues.addressInformation.apartment}
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  "addressInformation",
                                  "apartment"
                                )
                              }
                            />
                          </div>

                          <div className="address_input">
                            <div className="addform_input_half">
                              <FormLabel>Zip Code</FormLabel>
                              <Input
                                type="number"
                                className="input_mui_joy"
                                placeholder="Enter Zip Code"
                                value={formValues.addressInformation.zip}
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    "addressInformation",
                                    "zip"
                                  )
                                }
                              />
                              {(errors.addressInformation.zip ||
                                !errors.addressInformation.zipValidate ||
                                !errors.addressInformation.validZip) && (
                                <FormHelperText error>
                                  <Typography variant="caption" color="error">
                                    {errors.addressInformation.zip
                                      ? "Zip code is required"
                                      : !errors.addressInformation.zipValidate
                                      ? "Please enter a valid 5-digit Zip Code"
                                      : !errors.accountInformation.validZip
                                      ? "This is not a valid Zip Code"
                                      : ""}
                                  </Typography>
                                </FormHelperText>
                              )}
                            </div>
                            <div className="addform_input_half">
                              <FormLabel>City</FormLabel>
                              <Input
                                className="input_mui_joy"
                                placeholder="Enter City"
                                value={formValues.addressInformation.city}
                                readOnly
                                disabled
                              />
                            </div>
                          </div>
                          <div className="address_input">
                            <div className="addform_input_half">
                              <FormControl
                                fullWidth
                                error={Boolean(errors.addressInformation.state)}
                              >
                                <FormLabel>State/Province*</FormLabel>
                                <Input
                                  required
                                  className="input_mui_joy"
                                  placeholder="Enter State/Province"
                                  value={formValues.addressInformation.state}
                                  readOnly
                                  disabled
                                />
                              </FormControl>
                            </div>
                            <div className="addform_input_half">
                              <FormControl
                                fullWidth
                                error={Boolean(
                                  errors.addressInformation.country
                                )}
                              >
                                <FormLabel>Country*</FormLabel>
                                <Input
                                  required
                                  className="input_mui_joy"
                                  placeholder="Enter Country"
                                  value={formValues.addressInformation.country}
                                  readOnly
                                  disabled
                                />
                              </FormControl>
                            </div>
                          </div>
                        </>
                      )}
                      {activeStep === 2 && (
                        <>
                          <div>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                errors.accountInformation.username
                              )}
                            >
                              <FormLabel>Username*</FormLabel>
                                <Input
                                  required
                                  className="input_mui_joy"
                                  placeholder="Enter Username"
                                  value={formValues.accountInformation.username}
                                  onChange={(e) => {
                                    handleInputChange(e, "accountInformation", "username");
                                    setValidateExistsUsername(false);
                                  }}
                                  onBlur={(e) => {
                                    const lowerUsername = e.target.value.toLowerCase();
                                    setFormValues((prev) => {
                                      const updatedFormValues = {
                                        ...prev,
                                        accountInformation: {
                                          ...prev.accountInformation,
                                          username: lowerUsername,
                                        },
                                      };
                                      return updatedFormValues;
                                    });

                                    setTimeout(() => {
                                      getQR(); 
                                    }, 0); 
                                  }}
                                  />
                              {(errors.accountInformation.username ||
                                !errors.accountInformation.usernameValid ||
                                validateExistsUsername) && (
                                <FormHelperText>
                                  <Typography variant="caption" color="error">
                                    {errors.accountInformation.username ? (
                                      "Username is required"
                                    ) : /^\S+@\S+\.\S+$/.test(formValues.accountInformation.username) ? (
                                      "Username must not be an email address"
                                    ) : !errors.accountInformation.usernameValid ? (
                                      "Username must start with a lowercase letter and contain only lowercase letters, numbers, or underscores"
                                    ) : validateExistsUsername ? (
                                      "Username already exists"
                                    ) : (
                                      ""
                                    )}
                                  </Typography>
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                          <div>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                errors.accountInformation.password ||
                                  !errors.accountInformation.passwordValid
                              )}
                            >
                              <FormLabel>Password*</FormLabel>
                              <Input
                                className="input_mui_joy"
                                required
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                value={formValues.accountInformation.password}
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    "accountInformation",
                                    "password"
                                  )
                                }
                                autoComplete="new-password"
                              />
                              {(errors.accountInformation.password ||
                                !errors.accountInformation.passwordValid) && (
                                <FormHelperText>
                                  <Typography variant="caption" color="error">
                                    {errors.accountInformation.password
                                      ? "Password is required"
                                      : !errors.accountInformation.passwordValid
                                      ? "Password must be at least 10 characters long and include one number, one special character, and one uppercase letter"
                                      : ""}
                                  </Typography>
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>

                          <div>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                errors.accountInformation.confirmPassword ||
                                  !errors.accountInformation.passwordMatch
                              )}
                            >
                              <FormLabel>Confirm Password*</FormLabel>
                              <Input
                                className="input_mui_joy"
                                required
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Confirm Password"
                                value={
                                  formValues.accountInformation.confirmPassword
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    "accountInformation",
                                    "confirmPassword"
                                  )
                                }
                              />

                              {(errors.accountInformation.confirmPassword ||
                                !errors.accountInformation.passwordMatch) && (
                                <FormHelperText>
                                  <Typography variant="caption" color="error">
                                    {errors.accountInformation.confirmPassword
                                      ? "Confirm Password is required"
                                      : !errors.accountInformation.passwordMatch
                                      ? "Passwords must match"
                                      : ""}
                                  </Typography>
                                </FormHelperText>
                              )}
                            </FormControl>
                            <FormControl fullWidth style={{ marginTop: "8px" }}>
                              <FormControlLabel
                                label="Show Password"
                                control={
                                  <Checkbox
                                    checked={showPassword}
                                    onChange={handleCheckboxChange(
                                      "showPassword"
                                    )}
                                    color="primary"
                                  />
                                }
                              />
                            </FormControl>
                          </div>
                          
                          <div>
                        <FormControl fullWidth>
                          <FormControlLabel
                            label={
                              <Box display="flex" alignItems="center">
                                <Typography>
                                  I do accept&nbsp;
                                  <Link
                                    style={{ textDecoration: "none", color: "#4b4beb" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setTermsModalOpen(true);
                                    }}
                                  >
                                    terms and conditions
                                  </Link>
                                  &nbsp;of your site
                                </Typography>
                              </Box>
                            }
                            control={
                              <Checkbox
                                checked={hasAcceptedTerms}
                                onChange={(e) => {
                                  if (!hasAcceptedTerms) {
                                    setTermsModalOpen(true);
                                  }
                                }}
                                color="primary"
                                disabled
                              />
                            }
                          />
                        </FormControl>

                        {!hasAcceptedTerms && (
                          <FormHelperText>
                            <Typography variant="caption" color="error">
                              Please accept terms and conditions before continuing.
                            </Typography>
                          </FormHelperText>
                        )}
                          </div>
                        </>
                      )}
                      {activeStep === 3 && (
                        <>
                          {!isEmailVerified ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <p style={{ fontSize: "20px", fontWeight: "500", marginBottom: "20px" }}>
                                Enter the OTP sent to your email
                              </p>
                                {otpLoading ? (
                                  <p style={{ fontSize: "16px", color: "gray" }}>Sending OTP...</p>
                                ) : (
                                  <Input
                                    type="text"
                                    value={emailOtp}
                                    style={{ marginTop: "15px" }}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/\D/g, ""); 
                                      if (value.length <= 6) {
                                        setEmailOtp(value);
                                      }
                                    }} 
                                    placeholder="Enter 6-digit Email OTP"
                                    maxLength={6}
                                  />
                                )}
                             <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "10px", 
                                marginTop: "15px",
                              }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={handleEmailOtpVerify}
                                disabled={otpLoading}
                                fullWidth
                              >
                                Verify
                              </Button>

                              <Button
                                variant="contained"
                                color="primary"
                                onClick={handleResendOtp}
                                disabled={otpLoading}
                                fullWidth
                              >
                                Resend
                              </Button>
                            </div>
                            </div>
                          ) : (
                            <>
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <p style={{ fontSize: "20px", fontWeight: "500", marginBottom: "10px" }}>
                                  Scan this QR Code from Google Authenticator App
                                </p>
                                {qr ? (
                                  <>
                                    <div style={{ margin: "12px 0" }}>
                                      <QRCodeSVG value={qr} size={230} level="H" />
                                    </div>
                                    <div>
                                      <Input
                                        type="text"
                                        value={otp}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,6}$/.test(value)) {
                                              setOtp(value);
                                            }
                                          }}                                        
                                          placeholder="Enter 6-digit Google Authenticator code"
                                            maxLength={6}
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <div style={{ margin: "20px 0" }}>
                                    <p>Loading QR Code...</p>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                    <Box className="signup_card_button" sx={{ mb: 1 }}>
                      <Button
                        className="back_button"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        type="button"
                      >
                        Back
                      </Button>
                      {activeStep === steps.length - 1 && (
                        <Button
                        className="next_button"
                        variant="contained"
                        type="submit"
                        disabled={!isEmailVerified || otp.length !== 6}
                      >
                        Register
                        <FontAwesomeIcon className="arrow_icon" icon={faArrowRight} />
                      </Button>
                      
                      )}
                      {activeStep !== steps.length - 1 && (
                        <Button
                        className="next_button"
                        variant="contained"
                        onClick={handleNext}
                        type="button"
                      >
                        Next
                        <FontAwesomeIcon
                          className="arrow_icon"
                          icon={faArrowRight}
                        />
                      </Button>
                      )}
                    </Box>
                    <TermsAndConditionsModal
                      open={termsModalOpen}
                      onClose={() => setTermsModalOpen(false)}
                      onAgree={() => {
                        setHasAcceptedTerms(true);
                        setTermsModalOpen(false);
                        toast.success("Terms and Conditions accepted");
                      }}
                    />
                  </form>
                </Box>
              </div>
            </Card>
          </div>
        </div>
      
    </>
  );
};

export default Signup;
